export default __webpack_public_path__ + "static/media/Alexandru_Iordan_Resume.e11d4574.pdf";